import styled from '@emotion/styled';
import rem from '../../../utils/rem/rem';

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0 ${rem(32)};
`;

export const RadioWrapper = styled.div`
  width: ${rem(190)};
`;

export const TextAreaWrapper = styled.div`
  width: ${rem(632)};
`;